import React from "react";

export const useFocusWithin = <T extends Node>(
  ref: React.RefObject<T | null>,
  onFocus?: () => void,
  onBlur?: () => void,
) => {
  const handleFocus = (e: React.FocusEvent) => {
    if (
      onFocus &&
      ref.current &&
      !ref.current.contains(e.relatedTarget as Node)
    ) {
      onFocus();
    }
  };

  const handleBlur = (e: React.FocusEvent) => {
    if (
      onBlur &&
      ref.current &&
      !ref.current.contains(e.relatedTarget as Node)
    ) {
      onBlur();
    }
  };

  return {
    onFocus: handleFocus,
    onBlur: handleBlur,
  };
};
